import gql from 'graphql-tag';

export const registerChangeModalityStudies = gql`
  mutation registerChangeModalityOfStudies(
    $procedureId: Float!
    $newModality: String!
    $newModalityName: String!
    $newPeriod: String!
    $newCampus: String!
    $plan: String!
    $career: String!
    $period: String!
    $shift: String!
    $shiftDesc: String!
  ) {
    registerChangeModalityOfStudies(
      request: {
        procedureId: $procedureId
        newModality: $newModality
        newModalityName: $newModalityName
        newPeriod: $newPeriod
        newCampus: $newCampus
        plan: $plan
        career: $career
        period: $period
        targetShift: $shift
        shiftDesc: $shiftDesc
      }
    ) {
      error
      requestId
    }
  }
`;
